import { createTheme } from '@mui/material/styles';
import './tokens';

const darkTheme = createTheme({
  cssVariables: true,
  palette: {
    mode: 'dark',
    navigation: {
      background:        '#1F2335',
      subPanelBg:        '#3B415D',
      divider:           'rgba(255, 255, 255, 0.12)',
      tabSelectedBg:     '#1976D2',
      tabSelectedBorder: 'transparent',
      // Selected rows keep white subPanelText: 4.60:1.
      itemSelectedBg:    '#1976D2',
      // was #3A8AF7 — 2.93:1 on subPanelBg. Now 5.03:1.
      link:              '#8FBAFA',
      badge:             '#F73A5B',
      text:              '#FFFFFF',
      textMuted:         'rgba(255, 255, 255, 0.65)',
      subPanelText:      '#ffffff',
      subPanelTextMuted: 'rgba(255, 255, 255, 0.65)',
      subPanelAvatarBg:  'rgba(255, 255, 255, 0.2)',
    },
    surface: {
      appBackground:    '#3B4053',
      chatPanelBg:      '#3B4053',
      chatHeaderBg:     '#3B4053',
      inputBg:          '#3B4053',
      inputBorder:      'rgba(255, 255, 255, 0.18)',
      inputBorderFocus: '#3A8AF7',
      inputText:        'rgba(255, 255, 255, 0.85)',
      divider:          'rgba(255, 255, 255, 0.08)',
      primaryText:      '#FFFFFF',
      secondaryText:    'rgba(255, 255, 255, 0.65)',
      emptyStateIcon:   'rgba(255, 255, 255, 0.4)',
      toastBg:          '#ffffff',
      toastText:        '#1A1F2E',
    },
    chat: {
      userBubbleBg:          '#1976D2',
      userBubbleText:        '#FFFFFF',
      assistantBubbleBg:     '#2D3349',
      assistantBubbleBorder: 'rgba(255, 255, 255, 0.08)',
      bubbleText:            '#FFFFFF',
      // was 0.55 — 4.38:1 against the chat panel, just under the floor.
      // 0.72 gives 6.24:1 on the panel and 7.31:1 on the assistant bubble.
      sentStatus:            'rgba(255, 255, 255, 0.72)',
      // 7.22:1 on the assistant bubble, 5.94:1 on the chat panel.
      mentionText:           '#FFB74D',
      reactionAction:        'rgba(255, 255, 255, 0.65)',
      reactionActionHover:   '#FFFFFF',
      systemBubbleBg:        'rgba(255, 255, 255, 0.06)',
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          color: '#1A1F2E',
          '& .MuiTypography-root': { color: '#1A1F2E' },
          '& .MuiInputLabel-root': { color: '#6B7280' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#1565C0' },
          '& .MuiInputBase-input': { color: '#1A1F2E' },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D1D5DB' },
          '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9AA0A6' },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1565C0' },
          '& .MuiButton-text': { color: '#1A1F2E' },
          '& .MuiButton-text:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
          '& .MuiDivider-root': { borderColor: 'rgba(0,0,0,0.12)' },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#1A1F2E',
        },
      },
    },
    // Overlay surfaces stay light in dark mode here, as they already do for
    // Dialog and Alert above. Popover was the gap: it fell through to MUI's
    // dark paper while its contents kept light-mode text, so the account and
    // theme menus rendered near-black on near-black. Menu builds on Popover,
    // so this covers both. The descendant rules re-point the children that
    // resolve against the dark palette — divider, hover and text buttons all
    // pick colours meant for a dark background and vanish on white.
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          color: '#1A1F2E',
          '& .MuiDivider-root': { borderColor: 'rgba(0,0,0,0.12)' },
          '& .MuiButton-text': { color: '#1A1F2E' },
          '& .MuiListItemButton-root:hover, & .MuiMenuItem-root:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
          },
          '& .MuiMenuItem-root.Mui-selected': { backgroundColor: 'rgba(0,0,0,0.08)' },
        },
      },
    },
  },
  typography: {
    fontFamily: "'Proxima Nova', sans-serif",
  },
});

export default darkTheme;
